import React from "react";
import "./Servicos.css";
import IMGFOTOS from '../../assets/images/fotos-filmagens.jpg'
import IMGINSPECAO from '../../assets/images/inspecao.jpg'
import IMGEDICAO from '../../assets/images/edicao.jpg'


const Servicos = () => {
  const matchResult = window.matchMedia("(max-width:575px)").matches;

  return (
    <div className="servicos-container  p-5" id="servicos">
      <div className="container  d-flex justify-content-center">
        <div className="container-titulo-servicos">
          <h2 className="text-center text-white titulo-servicos">
            Nossos Serviços
          </h2>
        </div>
      </div>
      <div className={`container p-5 d-flex justify-content-center`}>
        <div className="row" style={{gap:'20px'}}>
          <div className="col-lg-4 p-3 container-servicos" style={{marginLeft: !matchResult ? '-40px': '0'}}>
            <img
              className="servicos-image"
              src={IMGINSPECAO}
            />
            <h2 className="bg-white text-center">Inspeção Predial</h2>
            <p className="text-white">
              Realizamos o serviço de foto e filmagem para inspeções de prédios,
              casas, entre outros imóveis. As inspeções são realizados junto ao
              responsável da obra !
            </p>
          </div>
          <div className="col-lg-4 p-3 container-servicos">
            <img
              className="servicos-image"
              src={IMGFOTOS}
            />
            <h2 className="bg-white text-center">Filmagens e Fotos</h2>
            <p className="text-white">
              Realizamos o serviço de foto e filmagem para imóveis,casamentos,
              aniversários, shows,entre outros.
            </p>
          </div>
          <div className="col-lg-4 p-3 container-servicos">
            <img
              className="servicos-image"
              src={IMGEDICAO}
            />
            <h2 className="bg-white text-center">Edição de Vídeos</h2>
            <p className="text-white">
              Realizamos o serviço de edição de vídeo para aqueles que já
              possuem o conteúdo, mas ainda não sabe exatamente o que fazer com
              eles
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Servicos;
